import type { ReactNode } from "react";

type SectionHeadingProps = {
  kicker?: string;
  title: string;
  desc?: string;
  action?: ReactNode;
  tone?: "dark" | "light";
};

export default function SectionHeading({
  kicker,
  title,
  desc,
  action,
  tone = "dark",
}: SectionHeadingProps) {
  const isLight = tone === "light";
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between md:mb-8">
      <div className="min-w-0">
        {kicker ? (
          <p
            className={`mb-2 flex items-center gap-2 font-label text-xs font-medium uppercase tracking-[0.2em] ${
              isLight ? "text-background-300" : "text-primary-600"
            }`}
          >
            <span
              className={`block h-px w-6 ${isLight ? "bg-accent-400" : "bg-primary-500"}`}
              aria-hidden="true"
            />
            {kicker}
          </p>
        ) : null}
        <h2
          className={`font-heading text-xl font-bold tracking-tight md:text-3xl ${
            isLight ? "text-background-50" : "text-foreground-950"
          }`}
        >
          {title}
        </h2>
        {desc ? (
          <p
            className={`mt-2 max-w-2xl text-sm leading-relaxed md:text-base ${
              isLight ? "text-background-300" : "text-foreground-600"
            }`}
          >
            {desc}
          </p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}